import {connect} from 'react-redux';
import {SliderSelectGroup as Component} from '../SliderSelectGroup';
import {gdndqSetSequence} from '@learningblocks/exp-redux';
import {gdndqSubmit} from '@learningblocks/exp-redux';

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    updateSelection: (params) => {
      dispatch(gdndqSetSequence(params));
    },
    submitAnswer: (id) => {
      dispatch(gdndqSubmit(id));
    },
  };
}
export const SliderSelectGroupRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
